export const RESET_STORE = "RESET_STORE";
export const LOGIN_REQUEST = "/users/token-auth-LOGIN_REQUEST";
export const LOGIN_SUCCESS = "/users/token-auth-LOGIN_SUCCESS";
export const LOGIN_FAILURE = "/users/token-auth-LOGIN_FAILURE";


// WEBPACK FOOTER //
// ./src/ducks/auth/constants.js